import "../css/QuoteButton.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const QuoteButton = () => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Get the hero section height (landing-page-container)
      const heroSection = document.querySelector('.landing-page-container');
      if (heroSection) {
        const heroHeight = heroSection.offsetHeight;
        // Show button only after scrolling past the hero section
        setShowButton(window.scrollY > heroHeight);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();
    
    // Clean up
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    navigate("/contact");
  };

  return (
    <>
      <div 
        className={`quote-button-container ${showButton ? 'visible' : 'hidden'}`} 
        onClick={handleClick}
      >
        <h2 className="quote-button">GET A FREE QUOTE</h2>
      </div>
    </>
  );
};

export default QuoteButton;